<template>
  <form
    id="cart"
    action="/cart"
    method="post"
    novalidate
    class="Cart__StickyForm"
  >
    <input type="hidden" name="discount" :value="swdCodes" />
    <button
      id="cart-submit"
      data-ht-element="checkout-button"
      type="submit"
      name="checkout"
      class="Cart-Receipt__Submit Cart-Receipt__Submit--Sticky checkout-now button button--primary"
      tabindex="0"
    >
      {{ store.terms.submit }}
    </button>
    <p class="p5">{{ store.terms.promo_code }}</p>
  </form>
</template>

<script setup>
import { useCartStore } from './Composables/Store';
import { computed } from 'vue';
const store = useCartStore();

const swdCodes = computed(() => {
  if (store?.tiers?.enabled) {
    const tierCodes = `${store.tiers.tier1.code},${store.tiers.tier2.code},${store.tiers.tier3.code}`;
    return tierCodes;
  } else {
    return store.swd?.code;
  }
});
</script>
